import { api } from '../../api/instance';

export const addressService = {
  getAddresses() {
    return api.get('v3/addresses').then((r) => r.addresses || []);
  },
  reverseGeocode(lat, lng) {
    return api.post('v3/addresses/reverse_geocode', { lat, lng });
  },
  getDistrict(lat, lng) {
    return api.post('v3/addresses/district', { lat, lng }).then((r) => r.district_id);
  },
  autocomplete(q, lat, lng) {
    return api.post('v3/addresses/autocomplete', { q, lat, lng });
  },
  geocode(address, prms) {
    return api.post('v3/addresses/geocode', { address, prms: prms || {} });
  },
  createAddress(address) {
    return api.post('v3/addresses', { address });
  },
  updateAddress(id, address) {
    return api.put(`v3/addresses/${id}`, { address });
  },
  deleteAddress(id) {
    return api.del(`v3/addresses/${id}`).then((r) => r.addresses || []);
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/addressStore/service.js